import { Upload, message } from "antd";
import { SearchableUpload } from "./EditScreenContentModal";
import { useRecoilState } from "recoil";
import { useContext } from "react";
import { memberState } from "../../state/atoms";
import { AppContext } from "../../AppContext";
import QRDisplayUploadsApi from "../../api/QRDisplayUploadsApi";

export const AcceptedDisplayFileTypes = ["image/jpeg", "image/png", "image/gif"];
export const displayFileTypeErrorMessage = "Supported file types are .png, .jpg/.jpeg, and .gif.";
export const maxDisplayFileSize = 10;
export const displayFileSizeErrorMessage = `This image can't be uploaded because it exceeds the ${maxDisplayFileSize} MB file size limit.`;

interface UploadDisplayImageProps {
  buttonText: string;
  className?: string;
  beforeUpload: () => void;
  afterUpload: () => void;
  uploads: SearchableUpload[];
  setUploads: (uploads: SearchableUpload[]) => void;
}

export default function UploadDisplayImage({buttonText, beforeUpload, afterUpload, uploads, setUploads, className=''}: UploadDisplayImageProps) {
  const [member] = useRecoilState(memberState);
  const { location } = useContext(AppContext);

  function onUploadChange(file: File) {
    if (AcceptedDisplayFileTypes.indexOf(file.type?.toLowerCase() ?? "") === -1) {
      message.error(displayFileTypeErrorMessage);
      return;
    }

    if ((file.size ?? 0) > maxDisplayFileSize * 1024 * 1025) {
      message.error(displayFileSizeErrorMessage);
      return;
    }

    var newFile = new File([file], file.name.replace(/ /g, "_"), {
      type: file.type,
      lastModified: file.lastModified
    });

    const formData = new FormData();
    formData.append("file", newFile);

    beforeUpload();

    QRDisplayUploadsApi.uploadDisplayAppImage(member.internalId.toString(), location.internalId!.toString(), formData).then((resp) => {
      setUploads([{ ...resp.data, visible: true, selected: false } as SearchableUpload, ...uploads]);
      afterUpload();
    }).catch(() => {
      console.error("Error uploading display image");
    });
  }

  return <Upload accept={AcceptedDisplayFileTypes.join(",")} showUploadList={false} beforeUpload={onUploadChange} className={className}>
    {buttonText}
  </Upload>
}